export default __webpack_public_path__ + "static/media/Punto_00_Finocchietti_SPA_Def.cf830668.aac";